export default __webpack_public_path__ + "static/media/Futura Medium font.4e762c29.ttf";